<template>
  <div class="box-father">
    <div style="height: 100%" v-if="!qusetionDetailDialog">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">任务管理&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>日常巡查任务</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="大小循环">
                  <el-select
                    filterable
                    placeholder="请选择大小循环"
                    clearable
                    v-model="form.handleRoleLevelInList"
                  >
                    <el-option
                      v-for="item in handleRoleLevelInListOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="任务状态">
                  <el-select
                    filterable
                    placeholder="请选择任务状态"
                    clearable
                    v-model="form.handleState"
                  >
                    <el-option
                      v-for="item in openFlagOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="案件号">
                  <el-input
                    v-model="form.caseNumber"
                    clearable
                    placeholder="请输入案件号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="事项名称">
                  <el-input
                    v-model="form.eventName"
                    clearable
                    placeholder="请输入事项名称"
                  ></el-input>
                </el-form-item>

                <el-form-item label="上报时间">
                  <el-date-picker
                    v-model="form.valueTime"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 400px !important"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="上报人员">
                  <el-input
                    v-model="form.reportUserName"
                    clearable
                    placeholder="请输入上报人员"
                  ></el-input>
                </el-form-item>
                <el-form-item label="上报网格">
                  <el-input
                    v-model="form.pointName"
                    clearable
                    placeholder="请输入上报网格"
                  ></el-input>
                </el-form-item>

                <el-form-item label="处置节点">
                  <el-select
                    filterable
                    placeholder="请选择处置节点"
                    clearable
                    v-model="form.handleRoleLevel"
                  >
                    <el-option
                      v-for="item in handleRoleLevelOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="处置部门">
                  <el-select
                    style="width: 356px"
                    v-model="form.handleDeptId"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in deptList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <!-- <div class="table-top-btns">
          <div class="left-btn">
            <div class="select-number">
              当前选中
              <span style="color: #3666ea">{{ selectedIdOptions.length }}</span>
              条
            </div>
            <el-button
              @click="delPointTypeFun(selectedIdOptions, true)"
              icon="el-icon-delete"
              class="delbtn"
              type="text"
              >批量删除</el-button
            >
          </div>
          <div class="right-btn">

            <el-button @click="addDialogFun({})" class="search el-icon-plus"
              >新增</el-button
            >
          </div>
        </div> -->
          <div class="table-top-btns">
            <div class="left-btn"></div>
            <div class="right-btn">
              <el-button
                @click="exportDetail({})"
                icon="el-icon-download"
                class="search"
                >导出</el-button
              >
            </div>
          </div>
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            :selectedIdOptions="selectedIdOptions"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            @handleSelectionChange="handleSelectionChange"
            @selectAll="selectAll"
            :maxHeight="450"
          >
            <template v-slot:enableStatus="{ scope }">
              <el-switch
                @change="
                  value => {
                    updatePointTypeFun(value, scope.row);
                  }
                "
                v-model="scope.row.enableStatus"
                :active-value="0"
                :inactive-value="1"
                active-color="#0495FF"
              >
              </el-switch>
            </template>
            <template v-slot:handlerState="{ scope }">
              <div class="flex-center">
                <span>{{ scope.row.handlerState }}</span>
                <!-- <div
                  v-if="scope.row.handlerState == '待处置'"
                  class="flex"
                  style="margin-left: 6px"
                >
                  <img src="@/assets/image/clock1.svg" alt="" /><span style="color: red"
                    >剩余12h32m</span
                  >
                </div>
                <div
                  v-if="scope.row.handlerState == '待认领'"
                  class="flex"
                  style="margin-left: 6px"
                >
                  <img src="@/assets/image/clock1.svg" alt="" /><span style="color: red"
                    >剩余12h32m</span
                  >
                </div> -->
              </div>
            </template>
            <template v-slot:handleRoleLevel="{ scope }">
              <div class="flex-center">
                <span v-if="scope.row.handleRoleLevel == 'R1'">网格员</span>
                <span v-if="scope.row.handleRoleLevel == 'R2'">社区书记</span>
                <span v-if="scope.row.handleRoleLevel == 'R3'">包片科室</span>
                <span v-if="scope.row.handleRoleLevel == 'R4'">职能部门</span>
              </div>
            </template>
            <template v-slot:handleRoleLevelInList="{ scope }">
              <div class="flex-center">
                <span
                  v-if="
                    scope.row.handleRoleLevel == 'R1' ||
                      scope.row.handleRoleLevel == 'R2' ||
                      scope.row.handleRoleLevel == 'R3'
                  "
                  >小循环</span
                >
                <span v-if="scope.row.handleRoleLevel == 'R4'">大循环</span>
              </div>
            </template>
            <template v-slot:dueSubmitTime="{ scope }">
              <div
                class="flex-center"
                style="color: #eb3538; align-items: center"
                v-if="scope.row.isOverdue || scope.row.isDueSubTime"
              >
                <div
                  style="
                    width: 4px;
                    height: 4px;
                    border-radius: 2px;
                    background: #eb3538;
                    margin-right: 4px;
                  "
                ></div>
                {{ scope.row.isOverdue ? '已超时' : scope.row.isDueSubTime }}
              </div>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                @click="qusetionDetail(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >问题详情</el-button
              >
              <el-button
                v-if="
                  scope.row.handlerState == '待认领' &&
                    (scope.row.handleRoleLevel == 'R2' ||
                      scope.row.handleRoleLevel == 'R3')
                "
                @click="problemHandleClick(scope.row, 1)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >申请协调</el-button
              >
              <el-button
                v-if="
                  scope.row.handlerState == '待认领' &&
                    (scope.row.handleRoleLevel == 'R2' ||
                      scope.row.handleRoleLevel == 'R3')
                "
                @click="problemDisposalClick(scope.row, 1)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >我方处置</el-button
              >
              <el-button
                v-if="
                  scope.row.handlerState == '待认领' &&
                    scope.row.handleRoleLevel == 'R4'
                "
                @click="claimClick(scope.row, 1)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >认领</el-button
              >
              <!-- <el-button
                @click="exportDetail"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >导出</el-button
              > -->
              <!-- <el-button
                @click="addDialogFun(scope.row)"
                :class="['tuihui', scope.row.handlerState == '已退回' ? 'yituihui' : '']"
                type="text"
                :disabled="scope.row.handlerState == '已退回'"
                >退回</el-button
              > -->
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">问题汇总分析&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>问题详情</div>
          </div>
        </div>
      </div>
      <div class="question-detail">
        <div>
          <div class="top">
            <div class="flex margin24">
              <img
                :src="require('@/assets/image/question-back.png')"
                style="width: 40px; height: 40px"
                @click="clickBackList"
              />
              <div class="map-content">
                <MapCom :pointInfo="detailHandleList"></MapCom>
              </div>
              <div class="right-top1">
                <div class="street">
                  {{ detailHandleList.eventName }}（{{
                    detailHandleList.caseNumber
                  }}）
                  <div class="disposition">
                    <img
                      v-if="detailHandleList.transitionState202501 == '已处置'"
                      :src="require('@/assets/image/ycz.svg')"
                    />
                    <img
                      v-if="detailHandleList.transitionState202501 == '未处置'"
                      :src="require('@/assets/image/wcz.svg')"
                    />
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-box-item">
                    <img src="@/assets/image/sbr.svg" alt="" />
                    <span style="color: #92979c">上报人</span>
                    <span>{{ detailHandleList.reportUserName }}</span>
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-box-item">
                    <img src="@/assets/image/phone.svg" alt="" />
                    <span style="color: #92979c">联系方式</span>
                    <span>{{ detailHandleList.reportUserTel }}</span>
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-box-item">
                    <img src="@/assets/image/clock.svg" alt="" />
                    <span style="color: #92979c">上报日期</span>
                    <span>{{ detailHandleList.reportTime }}</span>
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-box-item">
                    <img src="@/assets/image/dianwei.svg" alt="" />
                    <span style="color: #92979c">上报地点</span>
                    <span>{{ detailHandleList.reportAddress }}</span>
                  </div>
                </div>
                <div
                  class="remaining-time"
                  v-if="pointInfo.handlerState == '待认领'&& daojishiDate"
                >
                  <span v-if="isOverdue" style="color: #eb3538"> 已超期 </span>
                  <span v-else> 责任确认时限剩余 {{ daojishiDate }} </span>
                </div>
                <div
                  class="remaining-time"
                  style="color: #eb3538"
                  v-if="pointInfo.handlerState == '待处置'&& daojishiDate"
                >
                  <span v-if="isOverdue" style="color: #eb3538"> 已超期 </span>
                  <span v-else> 处置时限剩余 {{ daojishiDate }} </span>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="right-bottom">
              <div class="tabs">
                <div class="tabs-box">
                  <div
                    class="tabs-item"
                    :class="{ active: curTab == item.value }"
                    v-for="(item, index) in tabsOptions"
                    :key="index"
                    @click="tabsChange(item)"
                  >
                    {{ item.label }}
                  </div>
                </div>
              </div>
              <div class="form-content">
                <div style="display: flex;" v-if="curTab == 1">
                  <el-form :model="pointInfo">
                    <div class="flex">
                      <el-form-item label="事项名称" style="width: 48%;">
                        <el-input
                          disabled
                          v-model="pointInfo.eventName"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        label="主办单位"
                        style="width: 48%; margin-left: 20px"
                      >
                        <el-input
                          disabled
                          v-model="pointInfo.handleDeptName"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="taskDetail">
                      <el-form-item
                        label="问题描述"
                        style="display: flex; flex-direction: column; width: calc(60% + 20px);"
                      >
                        <el-input
                          disabled
                          v-model="pointInfo.taskDetail"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <!-- <el-form-item label="协办单位">
                  <el-input disabled v-model="pointInfo.type"></el-input>
                </el-form-item> -->

                    <el-form-item
                      label="现场照片"
                      class="taskDetail"
                      style="display: flex; flex-direction: column"
                    >
                      <div class="keyPic">
                        <el-image
                          class="imgPic"
                          v-for="(itempic, index) in pointInfo.taskFileJsonList"
                          :key="index"
                          :src="itempic"
                          :preview-src-list="pointInfo.taskFileJsonList"
                        >
                        </el-image>
                      </div>
                    </el-form-item>
                    <div
                      v-if="
                        (pointInfo.handleRoleLevel == 'R2' ||
                          pointInfo.handleRoleLevel == 'R3') &&
                          pointInfo.handlerState == '待认领'
                      "
                    >
                      <el-button type="primary" @click="problemHandleClick"
                        >申请协调处置</el-button
                      >
                      <el-button type="primary" @click="problemDisposalClick"
                        >确认我方处置</el-button
                      >
                    </div>
                    <div
                      v-if="
                        pointInfo.handleRoleLevel == 'R4' &&
                          pointInfo.handlerState == '待认领'
                      "
                    >
                      <el-button type="primary" @click="claimClick"
                        >认领</el-button
                      >
                    </div>
                  </el-form>
                  <!-- <flowRecord :id="pointInfo.taskId"></flowRecord> -->
                </div>
                <div v-if="curTab == 2">
                  <div class="flex" v-if="detailList.length">
                    <div class="fenbo">
                      <div
                        v-for="(item, index) in detailList"
                        @click="curClick(item, index)"
                        :key="index"
                        :class="[
                          'list',
                          curTabIndex == index ? 'activeList' : ''
                        ]"
                      >
                        <div class="flex">
                          <div class="handleDeptName">
                            {{ item.handleDeptName }}
                          </div>
                          <div
                            :class="[
                              'assignType',
                              item.assignType == '主办' ? 'zhuban' : ''
                            ]"
                          >
                            {{ item.assignType }}
                          </div>
                        </div>
                        <div class="flex assignTime">
                          <div>{{ item.assignTime }} 分拨</div>
                        </div>
                        <div class="disposition">
                          <img
                            v-if="
                              detailHandleList.transitionState202501 == '已处置'
                            "
                            :src="require('@/assets/image/ycz.svg')"
                          />
                          <img
                            v-if="
                              detailHandleList.transitionState202501 == '未处置'
                            "
                            :src="require('@/assets/image/wcz.svg')"
                          />
                        </div>
                      </div>
                    </div>
                    <div style="flex: 1">
                      <el-form :model="detailListForm">
                        <div class="flex">
                          <el-form-item label="处置人" style="width:50%;">
                            <el-input
                              disabled
                              v-model="detailListForm.handleUserName"
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            label="处置时间"
                            style="width:50%;margin-left: 20px"
                          >
                            <el-input
                              disabled
                              v-model="detailListForm.handleTime"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div
                          class="taskDetail"
                          v-if="detailListForm.state == '待处置'"
                        >
                          <el-form-item
                            label="处置措施"
                            style="display: flex; flex-direction: column"
                          >
                            <el-input
                              v-model="detailListForm.handleDetail"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="taskDetail" v-else>
                          <el-form-item
                            label="处置措施"
                            style="display: flex; flex-direction: column"
                          >
                            <el-input
                              disabled
                              v-model="detailListForm.handleDetail"
                              style="width: 960px"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <!-- <div class="taskDetail">
                      <el-form-item
                        label="处置地点"
                        style="display: flex; flex-direction: column"
                      >
                        <el-input
                          disabled
                          v-model="detailListForm.taskDetail"
                          style="width: 960px"
                        ></el-input>
                      </el-form-item>
                    </div> -->
                        <!-- <el-form-item label="协办单位">
                  <el-input disabled v-model="pointInfo.type"></el-input>
                </el-form-item> -->
                        <el-form-item
                          v-if="detailListForm.state == '待处置'"
                          label="现场照片"
                          class="taskDetail"
                          style="display: flex; flex-direction: column"
                        >
                          <div class="keyPic">
                            <el-upload
                              class="upload-demo"
                              action="#"
                              list-type="picture-card"
                              multiple
                              :http-request="uploadPicFileFun"
                              :file-list="picFilesJson"
                              :show-file-list="true"
                              accept="image/png,image/jpg,image/jpeg"
                            >
                              <i class="el-icon-plus"></i>
                            </el-upload>
                          </div>
                        </el-form-item>
                        <el-form-item
                          v-else
                          label="现场照片"
                          class="taskDetail"
                          style="display: flex; flex-direction: column"
                        >
                          <div class="keyPic">
                            <el-image
                              class="imgPic"
                              v-for="(itempic,
                              index) in detailListForm.handleFileJson"
                              :key="index"
                              :src="itempic.url"
                              :preview-src-list="
                                detailListForm.handleFileJsonList
                              "
                            >
                            </el-image>
                          </div>
                        </el-form-item>
                        <el-form-item
                          class="form-item"
                          style="text-align: right"
                          v-if="detailListForm.state == '待处置'"
                        >
                          <el-button @click="onHanldeClick" class="search"
                            >提交</el-button
                          >
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                  <div class="empty" v-else>
                    <div style="text-align: center">
                      <img src="@/assets/image/empty.png" alt="" />
                      <div>暂无数据</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <flowRecord :id="pointInfo.taskId || pointInfo.id"></flowRecord>
      </div>
    </div>

    <addDialog
      v-if="dialogVisible"
      @refreshList="getPointTypeListPageFun"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
    >
    </addDialog>
  </div>
</template>
<script>
import {
  getPointTypeListPage,
  updatePointType,
  delPointType
} from "@/api/point.js";
import { uploadFile } from "@/api/block.js";
import {
  reportTaskAssignPage,
  reportfullDetail,
  reportTaskHandleExp,
  sqClaimOrLevelUp202411v,
  bpClaimOrLevelUp202411v,
  claimTask,
  handleTask,
  handlePage202411vExp
} from "@/api/task.js";
import { downloadFile, getDeptTree } from "@/api/systemManagement.js";
import addDialog from "./components/addDialog.vue";
import commonTable from "@/components/table/index.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
import MapCom from "./components/map.vue";
import flowRecord from "../reportproblemAnalysis/flowRecord.vue";
export default {
  components: {
    addDialog,
    commonTable,
    MapCom,
    flowRecord
  },
  mixins: [pageChangeSelect],
  data() {
    return {
      form: {
        eventName: "",
        handleState: "",
        handleDeptId: "",
        reportTimeStart: "",
        reportTimeEnd: "",
        reportUserName: "",
        pointName: "",
        handleRoleLevel: "",
        handleRoleLevelInList: [],
        caseNumber: ""
      },
      openFlagOptions: [
        {
          label: "未处置",
          value: "未处置"
        },
        {
          label: "已处置",
          value: "已处置"
        }
      ],
      handleRoleLevelOptions: [
        {
          label: "网格员",
          value: "R1"
        },
        {
          label: "社区书记",
          value: "R2"
        },
        {
          label: "包片科室",
          value: "R3"
        },
        {
          label: "职能部门",
          value: "R4"
        }
      ],
      handleRoleLevelInListOptions: [
        {
          label: "大循环",
          value: ["R4"]
        },
        {
          label: "小循环",
          value: ["R1", "R2", "R3"]
        }
      ],
      dialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            slot: "handleRoleLevelInList",
            label: "大小循环",
            width: 100
          },
          {
            prop: "transitionState202501",
            label: "任务状态",
            width: 100
          },
          {
            prop: "caseNumber",
            label: "案件号",
            width: 150
          },
          {
            prop: "taskDetail",
            label: "问题描述",
            width: 200
          },
          {
            prop: "eventName",
            label: "事项名称",
            width: 200
          },

          {
            prop: "pointName",
            label: "点位",
            width: 140
          },
          {
            prop: "reportUserName",
            label: "上报人员",
            width: 140
          },

          {
            slot: "handleRoleLevel",
            label: "处置节点",
            width: 100
          },
          {
            prop: "handleDeptName",
            label: "处置部门",
            width: 200
          },
          // {
          //   prop: "dueClaimTime",
          //   label: "任务确认时间",
          //   width: 180
          // },
          {
            prop: "sqDueTime",
            label: "小循环截止时间",
            width: 180
          },
          {
            prop: "ksDueTime",
            label: "大循环截止时间",
            width: 180
          },
          {
            slot: "dueSubmitTime",
            label: "处置剩余时长",
            width: 140
          },
          {
            slot: "operation",
            label: "操作",
            width: 300,
            fixed: "right"
          }
        ]
      },
      curItem: {},
      qusetionDetailDialog: false,
      pointInfo: {},
      tabsOptions: [
        {
          label: "上报详情",
          value: "1"
        },
        {
          label: "问题处置",
          value: "2"
        }
      ],
      curTab: "1",
      curTabIndex: 0,
      detailList: [],
      detailListForm: {},
      deptList: [],
      daojishiDate: "",
      isOverdue: false,
      timer: null,
      tiemsp: "",
      picFilesJson: [],
      processLi: process.env.VUE_APP_API_IMG_PATH,
      timerMin: null
    };
  },
  mounted() {
    this.getTree();
    this.getPointTypeListPageFun();
    // this.timerMin = setInterval(() => {
    //   this.getPointTypeListPageFun();
    // }, 60000);
  },
  methods: {
    // 获取部门资源树形
    async getTree() {
      let params = {
        page: 999,
        size: 1,
        pid: "2000000035",
        data: true
      };
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptList = res.data.data;
      }
    },
    addDialogFun(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.selectedIdOptions = [];
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.selectedIdOptions = [];
      this.form.caseNumber = "";
      this.form.eventName = "";
      this.form.handleState = "";
      this.form.reportUserName = "";
      this.form.pointName = "";
      this.form.handleRoleLevelOptions = "";
      this.form.handleRoleLevelInList = [];
      this.form.handleDeptId = "";
      this.form.reportTimeStart = "";
      this.form.reportTimeEnd = "";
      this.form.valueTime = [];
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    // 开启关闭
    async updatePointTypeFun(value, item) {
      let params = {
        enableStatus: value,
        typeName: item.typeName,
        id: item.id
      };
      const res = await updatePointType(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.getPointTypeListPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 删除
    async delPointTypeFun(delList, flag) {
      let params = {
        delList: delList
      };
      const res = await delPointType(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        if (flag) this.selectedIdOptions = [];
        this.onSearch();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 模板下载
    async downloadFileFun() {
      const res = await downloadFile({
        filePath: "/templates/部门事项导入模板.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "部门事项导入模板.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },
    // 数据导入
    async importDataFun(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      const res = await importData(formData);
      if (res.data.code == 200) {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        this.onSearch();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    // 分页查询
    async getPointTypeListPageFun() {
      let params = {
        caseNumber: this.form.caseNumber,
        eventName: this.form.eventName,
        transitionState202501: this.form.handleState,
        handleDeptId: this.form.handleDeptId,
        reportTimeStart: this.form.valueTime && this.form.valueTime[0],
        reportTimeEnd: this.form.valueTime && this.form.valueTime[1],
        page: this.page.page,
        size: this.page.size,
        reportUserName: this.form.reportUserName,
        pointName: this.form.pointName,
        handleRoleLevel: this.form.handleRoleLevel,
        handleRoleLevelInList: this.form.handleRoleLevelInList || []
      };
      const res = await reportTaskAssignPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.dataList.tableData.forEach(item => {
          // if (item.handlerState == "待处置") {
          //   item.isDueSubTime = this.getHoursAndMinutesDates(
          //     new Date(),
          //     new Date(item.dueSubmitTime)
          //   );
          // }
          let isDetail = item.handleRoleLevel == "R4"
          ? item.ksDueTime
          : item.sqDueTime;
          if (isDetail) item.isDueSubTime = this.getHoursAndMinutesDates(new Date(), new Date(isDetail));
          else {
            let val = Number(new Date());
            let tiemsp = val + 60000;
            let date = new Date(tiemsp);
            let dataLi = item.handleRoleLevel == "R4" ? item.ksDueTime : item.sqDueTime;
            if (dataLi) {
              // 将日期转换为毫秒
              const ms1 = date.getTime();
              const ms2 = new Date(dataLi).getTime();

              // 计算两个日期之间的差值（毫秒）
              const diff = ms2 - ms1;

              // 转换差值为小时和分钟
              const hours = Math.floor(diff / 3600000); // 3600000 毫秒 = 1 小时
              const minutes = Math.floor((diff % 3600000) / 60000); // 60000 毫秒 = 1 分钟
              item.isOverdue = hours < 0;
              item.isDueSubTime =  `${hours}h${minutes}min`;
            }
          }
        });
        this.page.total = res.data.data.total;
      }
    },
    getHoursAndMinutesDates(date1, date2) {
      // 将日期转换为毫秒
      const ms1 = date1.getTime();
      const ms2 = date2.getTime();

      // 计算两个日期之间的差值（毫秒）
      const diff = ms2 - ms1;

      // 转换差值为小时和分钟
      const hours = Math.floor(diff / 3600000); // 3600000 毫秒 = 1 小时
      const minutes = Math.floor((diff % 3600000) / 60000); // 60000 毫秒 = 1 分钟
      return Number(hours) < 0 ? "已超期" : `${hours}h${minutes}min`;
    },
    async qusetionDetail(item) {
      this.pointInfo = item;
      item.taskFileJson = !item.taskFileJson
        ? []
        : JSON.parse(item.taskFileJson);
      item.taskFileJsonZip = !item.taskFileJsonZip
        ? []
        : JSON.parse(item.taskFileJsonZip);
      if (item.taskFileJson.length == item.taskFileJsonZip.length) {
        this.pointInfo.taskFileJsonList = item.taskFileJsonZip.map(item => {
          return this.processLi + item.filePath;
        });
      } else {
        this.pointInfo.taskFileJsonList = item.taskFileJson.map(item => {
          return item.url;
        });
      }
      // 获取详情
      const res = await reportfullDetail({
        id: item.taskId
      });
      if (res.data.code == 200) {
        this.detailHandleList = res.data.data;
        this.detailList = res.data.data.handleList;
        if (this.detailList.length > 0) {
          this.detailListForm = this.detailList && this.detailList[0];
          if (!this.detailListForm.handleFileJson) {
            this.detailListForm.handleFileJson = [];
            this.detailListForm.handleFileJsonList = [];
          } else {
            this.detailListForm.handleFileJson = JSON.parse(
              this.detailListForm.handleFileJson
            );
            this.detailListForm.handleFileJsonList = this.detailListForm.handleFileJson.map(
              item => item.url
            );
          }
        }
      }
      this.qusetionDetailDialog = true;
      this.picFilesJson = [];
      if (
        this.pointInfo.handlerState == "待处置" ||
        this.pointInfo.handlerState == "待认领"
      ) {
        // let dataLi =
        //   this.pointInfo.handlerState == "待认领"
        //     ? this.pointInfo.dueClaimTime
        //     : this.pointInfo.dueSubmitTime;
        console.log(this.pointInfo, "this.pointInfo");

        let dataLi =
          this.pointInfo.handleRoleLevel == "R4"
            ? this.detailHandleList.ksDueTime
            : this.detailHandleList.sqDueTime;
        if (dataLi)
          this.daojishiDate = this.getHoursAndMinutesBetweenDates(
            new Date(),
            new Date(dataLi)
          );

        this.commonServeTime();
      }
    },
    getHoursAndMinutesBetweenDates(date1, date2) {
      // 将日期转换为毫秒
      const ms1 = date1.getTime();
      const ms2 = date2.getTime();

      // 计算两个日期之间的差值（毫秒）
      const diff = ms2 - ms1;

      // 转换差值为小时和分钟
      const hours = Math.floor(diff / 3600000); // 3600000 毫秒 = 1 小时
      const minutes = Math.floor((diff % 3600000) / 60000); // 60000 毫秒 = 1 分钟
      this.isOverdue = hours < 0;
      return `${hours}h${minutes}min`;
    },
    getCurrentTime(val) {
      this.tiemsp = val + 60000;
      let date = new Date(this.tiemsp);
      let dataLi =
        this.pointInfo.handleRoleLevel == "R4"
          ? this.detailHandleList.ksDueTime
          : this.detailHandleList.sqDueTime;
      if (dataLi)
        this.daojishiDate = this.getHoursAndMinutesBetweenDates(
          date,
          new Date(dataLi)
        );
    },
    commonServeTime() {
      this.tiemsp = Number(new Date());
      this.timer = setInterval(() => {
        this.getCurrentTime(this.tiemsp);
      }, 60000);
    },
    tabsChange(item) {
      this.curTab = item.value;
    },
    curClick(item, index) {
      this.detailListForm = item;
      this.curTabIndex = index;
      if (!this.detailListForm.handleFileJson) {
        this.detailListForm.handleFileJson = [];
        this.detailListForm.handleFileJsonList = [];
      } else {
        this.detailListForm.handleFileJson = JSON.parse(
          this.detailList.handleFileJson
        );
        this.detailListForm.handleFileJsonList = this.detailListForm.handleFileJson.map(
          item => item.url
        );
      }
    },
    async exportDetail() {
      let res = await handlePage202411vExp({
        caseNumber: this.form.caseNumber,
        eventName: this.form.eventName,
        transitionState202501: this.form.handleState,
        handleDeptId: this.form.handleDeptId,
        reportTimeStart: this.form.valueTime && this.form.valueTime[0],
        reportTimeEnd: this.form.valueTime && this.form.valueTime[1],
        reportUserName: this.form.reportUserName,
        pointName: this.form.pointName,
        handleRoleLevel: this.form.handleRoleLevel,
        handleRoleLevelInList: this.form.handleRoleLevelInList || []
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "问题列表" + new Date().getTime() + ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
    },
    problemHandleClick(row, type) {
      this.pointInfo = type == 1 ? row : this.pointInfo;
      this.$confirm("您确认要「申请协调处置」吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let apiList =
            this.pointInfo.handleRoleLevel == "R2"
              ? sqClaimOrLevelUp202411v
              : bpClaimOrLevelUp202411v;
          let res = await apiList({
            id: this.pointInfo.taskHandleId,
            userSelect: "levelUP"
          });
          if (res.data.code == 200) {
            this.getPointTypeListPageFun();
            this.qusetionDetailDialog = false;
          }
        })
        .catch(() => {});
    },
    problemDisposalClick(row, type) {
      this.pointInfo = type == 1 ? row : this.pointInfo;
      this.$confirm("您确认要「确认我方处置」吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let apiList =
            this.pointInfo.handleRoleLevel == "R2"
              ? sqClaimOrLevelUp202411v
              : bpClaimOrLevelUp202411v;
          let res = await apiList({
            id: this.pointInfo.taskHandleId,
            userSelect: "claim"
          });
          if (res.data.code == 200) {
            this.getPointTypeListPageFun();
            this.qusetionDetailDialog = false;
          }
        })
        .catch(() => {});
    },
    async claimClick(row, type) {
      this.pointInfo = type == 1 ? row : this.pointInfo;
      this.$confirm("您确认要认领吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await claimTask({
            taskHandleId: this.pointInfo.taskHandleId
          });
          if (res.data.code == 200) {
            this.$message.success("认领成功");
            this.getPointTypeListPageFun();
            this.qusetionDetailDialog = false;
          } else {
            this.$message.success("认领失败");
          }
        })
        .catch(() => {});
    },
    async uploadPicFileFun(file) {
      console.log(file)
      const isImage = file.file.type == 'image/png' || file.file.type == 'image/jpg' ||  file.file.type == 'image/jpeg';
      if (isImage) {
        let formData = new FormData();
        formData.append("file", file.file);
        formData.append("objectName", "img");
        const res = await uploadFile(formData);
        if (res.data.code === 200) {
          this.picFilesJson.push({
            id: res.data.data.id,
            name: res.data.data.fileName,
            url:
              process.env.VUE_APP_API_DOMAIN +
              "/unified-code/file/download?filePath=" +
              res.data.data.filePath
          });
        }
      } else {
        // this.picFilesJson.splice(this.picFilesJson.length-1,1)
        return this.$message.error('应上传图片且格式为：png、jpg、jpeg 后缀')
      }
    },
    async onHanldeClick() {
      let res = await handleTask({
        handleDetail: this.detailListForm.handleDetail,
        handleFileJson: JSON.stringify(this.picFilesJson),
        id: this.pointInfo.taskHandleId
      });
      if (res.data.code == 200) {
        this.$message.success("操作成功");
        this.getPointTypeListPageFun();
        this.qusetionDetailDialog = false;
      } else {
        this.$message.success("操作失败");
      }
    },
    clickBackList() {
      this.qusetionDetailDialog = false;
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.timerMin) {
      clearInterval(this.timerMin);
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex {
  display: flex;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.question-detail {
  height: calc(100% - 56px);
  background-color: #fff;
  border-radius: 8px 8px 0px 0px;
  display: flex;
  .top {
    width: 100%;
    // height: 178px;
    padding: 24px 36px;
    background: url("~@/assets/image/question-bg.png") no-repeat center;
    background-size: 100% 100%;
  }

  .map-content {
    width: 375px;
    height: 178px;
    margin: 0 24px;
  }
}

.right-top1 {
  // width: 100%;
  margin-bottom: 8px;
  padding: 10px 24px;
  position: relative;

  .street {
    font-family: MiSans, MiSans;
    font-weight: 700;
    font-size: 24px;
    color: #494c4f;
    position: relative;

    .disposition {
      position: absolute;
      top: -10px;
      right: -80px;

      img {
        width: 65px;
        height: 54px;
      }
    }
  }

  .content {
    margin-top: 8px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 18px;
    color: #494c4f;
  }

  .info-box {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .info-box-item {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
      margin-right: 54px;

      img,
      span {
        margin-right: 8px;
      }

      img {
        height: 15px;
      }
    }

    .info-box-item:last-child {
      margin-right: 0;
    }
  }
}

.right-bottom {
  height: calc(100% - 214px);
  width: 100%;
  // max-height: 719px;
  // min-height: 561px;

  .tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 100px;
    padding-right: 24px;
    margin-bottom: 8px;

    .tabs-box {
      display: flex;
      align-items: center;

      .tabs-item {
        padding-top: 10px;
        padding-bottom: 8px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 20px;
        color: #92979c;
        margin-right: 48px;
        cursor: pointer;
        position: relative;
      }

      .tabs-item.active {
        font-family: MiSans, MiSans;
        font-weight: 700;
        font-size: 20px;
        color: #494c4f;
      }

      .tabs-item.active::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        height: 4px;
        width: 100%;
        background: #0090ff;
        border-radius: 2px;
      }
    }

    .tupian-box {
      display: flex;
      align-items: center;

      width: 68px;

      .tupian-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 8px;
        height: 38px;
      }

      .tupian-item:first-child {
        border-radius: 4px 0px 0px 4px;
        border: 1px solid #e0e0e0;

        img {
          height: 16px;
        }
      }

      .tupian-item:last-child {
        border-radius: 0px 4px 4px 0px;
        border: 1px solid #e0e0e0;

        img {
          height: 20px;
        }
      }
    }
  }

  .map-content {
    width: 100%;
    height: calc(100% - 56px);
    // min-height: 505px;
  }
}

.form-content {
  padding: 20px 100px;
}

.taskDetail {
  /deep/ .el-form-item__label {
    text-align: left;
  }
}

.keyPic {
  margin-top: 8px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  /deep/ .el-image {
    margin: 0 !important;
  }

  .imgPic {
    width: 234px;
    height: 234px;
    margin-right: 10px !important;
    border-radius: 4px;
  }
}

.fenbo {
  width: 360px;
  border-right: 1px solid #e0e0e0;
  margin-right: 20px;

  .list {
    width: 340px;

    height: 72px;
    background: #f7faff;
    border-radius: 4px;
    padding: 12px 24px;
    position: relative;
    margin-bottom: 12px;

    .handleDeptName {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 16px;
      color: #494c4f;
      line-height: 22px;
    }

    .assignType {
      margin-right: 8px;
      padding: 0 4px;
      height: 22px;
      background: rgba(138, 144, 154, 0.09);
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 22px;
    }

    .zhuban {
      background: rgba(4, 149, 255, 0.1);
      color: #0495ff;
    }

    .assignTime {
      margin-top: 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 19px;
    }

    .disposition {
      position: absolute;
      top: 10px;
      right: 20px;

      img {
        width: 65px;
        height: 54px;
      }
    }
  }

  .activeList {
    border: 1px solid #0495ff;
  }
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.yituihui {
  color: #c4c6cc;
}

.remaining-time {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #ff8b46;
  background: rgba(255, 139, 70, 0.1);
  border-radius: 4px;
  margin: 0 4px 0 6px;
  padding: 2px 4px;
  display: inline-block;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/problemAnalysis/index.vue